"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topo = {
    "name": "MAPA TOPOGRAFICZNA",
    "format": "image/jpeg",
    "tiles": {
        "EPSG_2180": [
            {
                "scaleDenominator": 7559523.809523809,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 1,
                    "height": 1
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 0
                    },
                    "col": {
                        "min": 0,
                        "max": 0
                    }
                }
            },
            {
                "scaleDenominator": 3779761.9047619044,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 2,
                    "height": 2
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 1
                    },
                    "col": {
                        "min": 0,
                        "max": 1
                    }
                }
            },
            {
                "scaleDenominator": 1889880.9523809522,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 3,
                    "height": 3
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 2
                    },
                    "col": {
                        "min": 0,
                        "max": 2
                    }
                }
            },
            {
                "scaleDenominator": 944940.4761904761,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 6,
                    "height": 6
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 5
                    },
                    "col": {
                        "min": 0,
                        "max": 5
                    }
                }
            },
            {
                "scaleDenominator": 472470.23809523805,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 12,
                    "height": 12
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 11
                    },
                    "col": {
                        "min": 0,
                        "max": 11
                    }
                }
            },
            {
                "scaleDenominator": 236235.11904761902,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 24,
                    "height": 23
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 22
                    },
                    "col": {
                        "min": 0,
                        "max": 23
                    }
                }
            },
            {
                "scaleDenominator": 94494.04761904762,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 60,
                    "height": 57
                },
                "limits": {
                    "row": {
                        "min": 1,
                        "max": 56
                    },
                    "col": {
                        "min": 1,
                        "max": 59
                    }
                }
            },
            {
                "scaleDenominator": 47247.02380952381,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 120,
                    "height": 113
                },
                "limits": {
                    "row": {
                        "min": 2,
                        "max": 112
                    },
                    "col": {
                        "min": 3,
                        "max": 119
                    }
                }
            },
            {
                "scaleDenominator": 23623.511904761905,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 240,
                    "height": 225
                },
                "limits": {
                    "row": {
                        "min": 5,
                        "max": 224
                    },
                    "col": {
                        "min": 7,
                        "max": 239
                    }
                }
            },
            {
                "scaleDenominator": 9449.404761904761,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 598,
                    "height": 562
                },
                "limits": {
                    "row": {
                        "min": 14,
                        "max": 561
                    },
                    "col": {
                        "min": 18,
                        "max": 597
                    }
                }
            },
            {
                "scaleDenominator": 4724.702380952381,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 1196,
                    "height": 1123
                },
                "limits": {
                    "row": {
                        "min": 29,
                        "max": 1122
                    },
                    "col": {
                        "min": 36,
                        "max": 1195
                    }
                }
            },
            {
                "scaleDenominator": 1889.8809523809523,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 2990,
                    "height": 2806
                },
                "limits": {
                    "row": {
                        "min": 73,
                        "max": 2805
                    },
                    "col": {
                        "min": 92,
                        "max": 2989
                    }
                }
            },
            {
                "scaleDenominator": 944.9404761904761,
                "origin": [
                    850000,
                    100000
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 5980,
                    "height": 5611
                },
                "limits": {
                    "row": {
                        "min": 147,
                        "max": 5610
                    },
                    "col": {
                        "min": 184,
                        "max": 5979
                    }
                }
            }
        ],
        "EPSG_4326": [
            {
                "scaleDenominator": 7559523.809523809,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 2,
                    "height": 1
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 0
                    },
                    "col": {
                        "min": 0,
                        "max": 1
                    }
                }
            },
            {
                "scaleDenominator": 3779761.9047619044,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 3,
                    "height": 2
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 1
                    },
                    "col": {
                        "min": 0,
                        "max": 2
                    }
                }
            },
            {
                "scaleDenominator": 1889880.9523809522,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 6,
                    "height": 4
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 3
                    },
                    "col": {
                        "min": 0,
                        "max": 5
                    }
                }
            },
            {
                "scaleDenominator": 944940.4761904761,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 12,
                    "height": 7
                },
                "limits": {
                    "row": {
                        "min": 0,
                        "max": 6
                    },
                    "col": {
                        "min": 0,
                        "max": 11
                    }
                }
            },
            {
                "scaleDenominator": 472470.23809523805,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 23,
                    "height": 13
                },
                "limits": {
                    "row": {
                        "min": 1,
                        "max": 12
                    },
                    "col": {
                        "min": 1,
                        "max": 22
                    }
                }
            },
            {
                "scaleDenominator": 236235.11904761902,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 45,
                    "height": 25
                },
                "limits": {
                    "row": {
                        "min": 2,
                        "max": 24
                    },
                    "col": {
                        "min": 3,
                        "max": 44
                    }
                }
            },
            {
                "scaleDenominator": 94494.04761904762,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 111,
                    "height": 62
                },
                "limits": {
                    "row": {
                        "min": 5,
                        "max": 61
                    },
                    "col": {
                        "min": 9,
                        "max": 110
                    }
                }
            },
            {
                "scaleDenominator": 47247.02380952381,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 221,
                    "height": 123
                },
                "limits": {
                    "row": {
                        "min": 10,
                        "max": 122
                    },
                    "col": {
                        "min": 18,
                        "max": 220
                    }
                }
            },
            {
                "scaleDenominator": 23623.511904761905,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 442,
                    "height": 245
                },
                "limits": {
                    "row": {
                        "min": 21,
                        "max": 244
                    },
                    "col": {
                        "min": 36,
                        "max": 441
                    }
                }
            },
            {
                "scaleDenominator": 9449.404761904761,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 1104,
                    "height": 613
                },
                "limits": {
                    "row": {
                        "min": 54,
                        "max": 612
                    },
                    "col": {
                        "min": 90,
                        "max": 1103
                    }
                }
            },
            {
                "scaleDenominator": 4724.702380952381,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 2207,
                    "height": 1225
                },
                "limits": {
                    "row": {
                        "min": 109,
                        "max": 1224
                    },
                    "col": {
                        "min": 181,
                        "max": 2206
                    }
                }
            },
            {
                "scaleDenominator": 1889.8809523809523,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 5517,
                    "height": 3061
                },
                "limits": {
                    "row": {
                        "min": 273,
                        "max": 3060
                    },
                    "col": {
                        "min": 453,
                        "max": 5516
                    }
                }
            },
            {
                "scaleDenominator": 944.9404761904761,
                "origin": [
                    56,
                    12
                ],
                "tileSize": {
                    "width": 512,
                    "height": 512
                },
                "matrixSize": {
                    "width": 11034,
                    "height": 6121
                },
                "limits": {
                    "row": {
                        "min": 547,
                        "max": 6120
                    },
                    "col": {
                        "min": 906,
                        "max": 11033
                    }
                }
            }
        ]
    },
    "url": "http://mapy.geoportal.gov.pl/wss/service/WMTS/guest/wmts/TOPO"
};



//////////////////
// WEBPACK FOOTER
// ./src/capabilities/topo.ts
// module id = 278
// module chunks = 0 1